import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { loadPlanComparison, planVars, subscribePlanPricing } from '../lib/planPricing';

// Import translation files
import enUI from './locales/en/ui.json';
import frUI from './locales/fr/ui.json';
import esUI from './locales/es/ui.json';
import deUI from './locales/de/ui.json';
import ptUI from './locales/pt/ui.json';
import jaUI from './locales/ja/ui.json';
import zhUI from './locales/zh/ui.json';
import ruUI from './locales/ru/ui.json';
import arUI from './locales/ar/ui.json';
import hiUI from './locales/hi/ui.json';
import swUI from './locales/sw/ui.json';

const resources = {
  en: { translation: enUI },
  fr: { translation: frUI },
  es: { translation: esUI },
  de: { translation: deUI },
  pt: { translation: ptUI },
  ja: { translation: jaUI },
  zh: { translation: zhUI },
  ru: { translation: ruUI },
  ar: { translation: arUI },
  hi: { translation: hiUI },
  sw: { translation: swUI },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
      // Plan prices in copy, e.g. {{proMonthly}}. Updated once Clerk's plans load.
      defaultVariables: planVars(),
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      caches: ['localStorage'],
    }
  });

subscribePlanPricing(() => {
  Object.assign(i18n.options.interpolation!.defaultVariables!, planVars());
  i18n.emit('languageChanged', i18n.language);
});
loadPlanComparison().catch(() => { /* keep the fallback prices */ });

export default i18n;
